/**
 * Icon-only control — close buttons, toolbar icons, etc.
 * Not for labeled CTAs (use Button).
 */
export function IconButton({
  children,
  variant = 'ghost',
  size = 'md',
  className = '',
  type = 'button',
  ...props
}) {
  const variantClasses = {
    primary:
      'bg-primary text-white hover:opacity-95 rounded-full disabled:opacity-50',
    muted:
      'text-text-muted hover:text-text-primary hover:bg-layer-7-hover rounded-lg border border-transparent',
    ghost:
      'text-text-muted hover:text-text-primary hover:bg-layer-7-hover rounded-lg',
  }[variant];

  const sizeClasses = {
    sm: 'w-6 h-6 p-0 aspect-square',
    md: 'w-8 h-8 p-1.5 aspect-square',
    lg: 'w-10 h-10 p-2 aspect-square',
  }[size];

  return (
    <button
      type={type}
      className={`inline-flex items-center justify-center shrink-0 focus:outline-none transition-all duration-200 disabled:cursor-not-allowed ${variantClasses} ${sizeClasses} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

function XIcon({ className = 'w-3 h-3 stroke-[3]' }) {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}

/**
 * Standard modal/drawer close control.
 */
export function CloseButton({
  variant = 'primary',
  size = 'sm',
  className = '',
  'aria-label': ariaLabel = 'Close',
  ...props
}) {
  const iconClass = size === 'sm' ? 'w-3 h-3 stroke-[3]' : 'w-5 h-5 stroke-[2]';

  return (
    <IconButton
      variant={variant}
      size={size}
      className={className}
      aria-label={ariaLabel}
      {...props}
    >
      <XIcon className={iconClass} />
    </IconButton>
  );
}
